import dayjs from "dayjs";
import { PreviewInvoiceType } from "../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/enums/PreviewInvoiceType";

export function postprocessInvoicePreview(previewType, invoiceNext) {
    let newInvoiceNext = { ...invoiceNext };
    switch (previewType) {
        // case PreviewInvoiceType.SWITCH_SAME_CYCLE_UPGRADE:
        // case PreviewInvoiceType.SWITCH_SAME_CYCLE_DOWNGRADE:
        // case PreviewInvoiceType.PARTNER:
        case PreviewInvoiceType.SWITCH_DIFF_BILLING_CYCLE: {
            const {
                billing_cycle, first_billing_date,
            } = invoiceNext;

            let nextBilling = dayjs(first_billing_date).format('YYYY-MM-DD HH:mm');
            if (first_billing_date && dayjs(first_billing_date).isBefore(dayjs())) {
                nextBilling = dayjs(first_billing_date)
                    .add(billing_cycle, 'month')
                    .format('YYYY-MM-DD HH:mm');
            }

            newInvoiceNext = {
                ...invoiceNext,
                first_billing_date: nextBilling,
            };
            break;
        }
        default:
            break;
    }
    return newInvoiceNext;
}
